import { useGlobalStore } from '@shared/store';
import { useUrlSearchParams } from '@vueuse/core';
import { Toast } from 'vant';
import { commonApi } from '../../apis';

// 初始化 userId 转换 staffId
export const initUserIdToStaffId = async () => {
  try {
    const globalStore = useGlobalStore();
    const { currentCorpId } = globalStore.appData;
    // 获取 url 参数， 内部调用 window.location.search
    const params = useUrlSearchParams('history');

    // 同名参数有多个值时，取第一个值
    const userId = Array.isArray(params.userId) ? params.userId[0] : params.userId;

    // 调用时机：页面 url 无 staffId，即 globalStore.firstEntryStaffId 空值，同时 url 有 userId
    if (!globalStore.firstEntryStaffId && userId) {
      const { ret, retdata = {} } = await commonApi.getUserIdToStaffId<any, any>({
        corpId: currentCorpId,
        userId: decodeURIComponent(userId),
      });

      if (ret === 0) {
        const staffId = retdata.detail?.staffId || '';
        if (staffId) {
          // 内部调用 window.history.replaceState，在不刷新页面情况下修改 url
          params.staffId = staffId;

          // 更新 firstEntryStaffId
          globalStore.setFirstEntryStaffId(staffId);

          // 更新视图类型
          globalStore.setIsManagerView(staffId);
        } else {
          Toast.fail('无效链接，请稍后重试');
        }
      }
    }
  } catch (error) {
    console.log('初始化 userId 转换 staffId 错误：', error);
  }
};
